/**
 * @file Emoji Bar component
 * @author Willem Jan Weitering
 */
import { OnInit } from '@angular/core';
import { AlertsService } from '../../core/alerts.service';
/**
 * Class for the EmojiBar component that provides an embeddable emoji bar for user reactions.
 */
var EmojiBarComponent = /** @class */ (function () {
    /**
     * Constructs an EmojiBar Component
     */
    function EmojiBarComponent(alertsService) {
        this.alertsService = alertsService;
        this.popupVisible = false;
        this.user = 'a';
        this.emojis = ['THUMB-UP', 'THUMB-DOWN', 'LAUGH', 'HOORAY', 'CONFUSED', 'HEART', 'ROCKET', 'EYES'];
        this.imageUrls = {
            'THUMB-UP': require('../assets/images/thumb-up.png'),
            'THUMB-DOWN': require('../assets/images/thumb-down.png'),
            'LAUGH': require('../assets/images/laugh.png'),
            'HOORAY': require('../assets/images/hooray.png'),
            'CONFUSED': require('../assets/images/confused.png'),
            'HEART': require('../assets/images/heart.png'),
            'ROCKET': require('../assets/images/rocket.png'),
            'EYES': require('../assets/images/eyes.png')
        };
        /* Contains for each emoji (key) an array of users (value) */
        this.items = undefined;
        this.resetMessage();
    }
    /**
     * An outside click event
     */
    EmojiBarComponent.prototype.clickOutside = function (e) {
        this.popupVisible = false;
        this.resetMessage();
    };
    /**
     * Add emoji reaction
     * @param item Emoji to be added
     */
    EmojiBarComponent.prototype.addReaction = function (item) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            // coming: call to backend
            _this.items[item].push(_this.user);
            resolve(item);
        });
    };
    /**
     * Remove emoji reaction
     * @param item Emoji to be removed
     * @param index Index in the emoji array of user to be removed
     */
    EmojiBarComponent.prototype.deleteReaction = function (item, index) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            // coming: call to backend
            _this.items[item].splice(index, 1);
            resolve(item);
        });
    };
    /**
     * Toggle user reaction
     * @param item Emoji to be toggled
     */
    EmojiBarComponent.prototype.toggleReaction = function (item) {
        var _this = this;
        var index = this.items[item].indexOf(this.user, 0);
        if (index < 0) {
            this.addReaction(item).catch(function (error) {
                _this.alertsService.createAlert('warning', 'APP.SOCIAL.EMOJI_UNSUCCESSFULLY_ADDED', error.message);
            });
        }
        else {
            this.deleteReaction(item, index).catch(function (error) {
                _this.alertsService.createAlert('warning', 'APP.SOCIAL.EMOJI_UNSUCCESSFULLY_DELETED', error.message);
            });
        }
        this.popupVisible = false;
    };
    /**
     * Toggles popup visibility
     */
    EmojiBarComponent.prototype.togglePopup = function () {
        this.popupVisible = !this.popupVisible;
        if (this.popupVisible) {
            this.resetMessage();
        }
    };
    /**
     * resetMessage resets message to initial value
     */
    EmojiBarComponent.prototype.resetMessage = function () {
        this.popupText = 'PICK_REACTION';
    };
    /**
     * Set Popup Text
     * @param text Text to be set
     */
    EmojiBarComponent.prototype.setPopupText = function (text) {
        if (!text) {
            this.resetMessage();
        }
        else {
            this.popupText = text;
        }
    };
    /**
     * Is called directly after the creation of this component
     */
    EmojiBarComponent.prototype.ngOnInit = function () {
        var _this = this;
        // Fake loading of items
        var users = ['a', 'b', 'c', 'd', 'e', 'f'];
        setTimeout(function () {
            _this.items = {
                'THUMB-UP': [],
                'THUMB-DOWN': [],
                'LAUGH': [],
                'HOORAY': [],
                'CONFUSED': [],
                'HEART': [],
                'ROCKET': [],
                'EYES': []
            };
            // for all 8 emojis in items..
            for (var i = 0, t = 8; i < t; i++) {
                // fill some emoji arrays with a random number of random items
                if (Math.random() >= 0.8) {
                    for (var j = 0, s = Math.round(Math.random() * 4); j < s; j++) {
                        _this.items[_this.emojis[i]].push(users[Math.floor(Math.random() * t)]);
                    }
                }
            }
        }, 2000);
    };
    return EmojiBarComponent;
}());
export { EmojiBarComponent };
